module.exports = __webpack_public_path__ + "static/media/exibex.a2320215.png";